import { CaseValidation } from 'containers/pages/cases/types';

const initCaseValid: CaseValidation = {
	Title: { isErr: false, errMsg: '', canNotSave: true },
	CustomerId: { isErr: false, errMsg: '', canNotSave: true },
	ConsultantId: { isErr: false, errMsg: '', canNotSave: true },
	StatusId: { isErr: false, errMsg: '', canNotSave: false }, // Default StatusId='1' is set
};

export const loadedCaseValid: CaseValidation = {
	Title: { isErr: false, errMsg: '', canNotSave: false },
	CustomerId: { isErr: false, errMsg: '', canNotSave: false },
	ConsultantId: { isErr: false, errMsg: '', canNotSave: false },
	StatusId: { isErr: false, errMsg: '', canNotSave: false },
};

export default initCaseValid;
